module.exports = __webpack_public_path__ + "img/external-link-alt-solid.233fab14.svg";